const data = [
  { title: 'SCORM 1.2', type: '1_2' },
  { title: 'SCORM 2004 3rd', type: '2004' },
]

export default data
